function enforceMaxQuantity() {
  const cartItemsEl = document.querySelector('cart-items');
  if (!cartItemsEl) return;

  const qtyInputs = cartItemsEl.querySelectorAll('input[name="updates[]"]');
  qtyInputs.forEach(input => {
    const val = parseInt(input.value);
    if (val > 10) {
      const index = input.dataset.index;
      const variantId = input.dataset.quantityVariantId;
      // Auto update quantity to 10 on the server
      cartItemsEl.updateQuantity(
        index,
        10,
        { currentTarget: input, preventDefault: () => {} },
        'updates[]',
        variantId
      );
    }
  });
}

// Run on initial page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', enforceMaxQuantity);
} else {
  enforceMaxQuantity();
}

// Subscribe to cart updates from pubsub
document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      // Run after DOM paint completes
      setTimeout(enforceMaxQuantity, 100);

      // Dynamically update the main cart title item count
      const cartTitle = document.querySelector('.title-wrapper-with-link h1.title');
      if (cartTitle && event && event.cartData && typeof event.cartData.item_count !== 'undefined') {
        cartTitle.textContent = cartTitle.textContent.replace(/\(\d+\)/, `(${event.cartData.item_count})`);
      }
    });
  }
});

// Click handler for custom spin buttons
document.addEventListener('click', (event) => {
  const btn = event.target.closest('.qty-spin-button');
  if (!btn) return;

  event.preventDefault();
  const container = btn.closest('.item-quantity');
  if (!container) return;

  const input = container.querySelector('input[type="number"]');
  if (!input) return;

  let val = parseInt(input.value) || 1;
  if (btn.classList.contains('qty-spin-up')) {
    if (val < 10) {
      input.value = val + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  } else if (btn.classList.contains('qty-spin-down')) {
    if (val > 1) {
      input.value = val - 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
});

// Intercept subscription plan updates
document.addEventListener('change', (event) => {
  const select = event.target.closest('select[name="selling_plan"]');
  if (!select) return;

  // Intercept the change event so cart.js's validateQuantity is NOT triggered
  event.stopPropagation();
  event.stopImmediatePropagation();

  const line = select.dataset.index;
  const sellingPlanId = select.value;
  const cartItemsEl = document.querySelector('cart-items');

  if (!cartItemsEl || !line) return;

  // Enable loader indicator
  cartItemsEl.enableLoading(line);

  // POST request to Shopify Cart change endpoint to update the selling plan
  const sectionsToRender = (cartItemsEl && typeof cartItemsEl.getSectionsToRender === 'function') ? cartItemsEl.getSectionsToRender() : [
    {
      id: 'main-cart-items',
      section: document.getElementById('main-cart-items')?.dataset?.id || 'main-cart-items',
      selector: '#main-cart-items',
    },
    {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section',
    },
    {
      id: 'main-cart-footer',
      section: document.getElementById('main-cart-footer')?.dataset?.id || 'main-cart-footer',
      selector: '.js-contents',
    },
    {
      id: 'main-cart-items-addons',
      section: document.getElementById('main-cart-items')?.dataset?.id || 'main-cart-items',
      selector: '#main-cart-items-addons',
    }
  ];

  const body = JSON.stringify({
    line: line,
    selling_plan: sellingPlanId || "",
    sections: sectionsToRender.map((section) => section.section),
    sections_url: window.location.pathname
  });

  fetch(window.routes ? window.routes.cart_change_url : '/cart/change', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: body
  })
  .then((response) => response.json())
  .then((parsedState) => {
    if (parsedState.errors) {
      console.error(parsedState.errors);
      if (typeof cartItemsEl.updateLiveRegions === 'function') {
        cartItemsEl.updateLiveRegions(line, parsedState.errors);
      }
      return;
    }

    // Toggle main empty state flags
    cartItemsEl.classList.toggle('is-empty', parsedState.item_count === 0);
    const cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

    // Replace the specified sections with the updated server-rendered HTML response
    sectionsToRender.forEach((section) => {
      const containerEl = document.getElementById(section.id);
      if (!containerEl) return;
      const elementToReplace = containerEl.querySelector(section.selector) || containerEl;
      if (elementToReplace && parsedState.sections[section.section]) {
        if (typeof cartItemsEl.getSectionInnerHTML === 'function') {
          elementToReplace.innerHTML = cartItemsEl.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        } else {
          const doc = new DOMParser().parseFromString(parsedState.sections[section.section], 'text/html');
          const innerNode = doc.querySelector(section.selector) || doc.body;
          elementToReplace.innerHTML = innerNode.innerHTML;
        }
      }
    });

    // Notify other components/listeners that the cart has been updated
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState });
    }
  })
  .catch((error) => {
    console.error('Error updating selling plan:', error);
    const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    if (errors) errors.textContent = window.cartStrings.error;
  })
  .finally(() => {
    cartItemsEl.disableLoading(line);
  });
}, true); // Use capture phase to intercept before cart.js!

// Add-Ons Checkbox Handling & Conflict Logic
function initCartAddons() {
  const addonsContainer = document.querySelector('.add-ons-offers');
  if (!addonsContainer) return;

  const checkboxRush = document.getElementById('rush-handling');
  const checkboxInsurance = document.getElementById('shipping-insurance');
  const checkboxCombo = document.getElementById('rush-processing-shipping-insurance');

  function updateAddonUI() {
    const isRushChecked = checkboxRush && checkboxRush.checked;
    const isInsuranceChecked = checkboxInsurance && checkboxInsurance.checked;
    const isComboChecked = checkboxCombo && checkboxCombo.checked;

    // Rule 1: If Box 1 OR Box 2 is checked, Box 3 (Combo) is disabled
    if (checkboxCombo) {
      checkboxCombo.disabled = (isRushChecked || isInsuranceChecked);
    }

    // Rule 2: If Box 3 (Combo) is checked, Box 1 and Box 2 are disabled
    if (checkboxRush) {
      checkboxRush.disabled = isComboChecked;
    }
    if (checkboxInsurance) {
      checkboxInsurance.disabled = isComboChecked;
    }
  }

  // Set initial UI states based on active checkboxes
  updateAddonUI();

  const checkboxes = [checkboxRush, checkboxInsurance, checkboxCombo];
  checkboxes.forEach(checkbox => {
    if (!checkbox) return;

    // Remove any existing event listeners to avoid duplicates
    const newCheckbox = checkbox.cloneNode(true);
    checkbox.parentNode.replaceChild(newCheckbox, checkbox);

    newCheckbox.addEventListener('change', async (event) => {
      const isChecked = newCheckbox.checked;
      const variantId = newCheckbox.dataset.variantId;

      if (!variantId) {
        console.error('Variant ID not found on addon checkbox');
        return;
      }

      // Show loader on cart
      const mainCartItems = document.getElementById('main-cart-items');
      if (mainCartItems) mainCartItems.classList.add('cart__items--disabled');

      // Temporarily disable checkboxes during the update request
      const currentCheckboxes = [
        document.getElementById('rush-handling'),
        document.getElementById('shipping-insurance'),
        document.getElementById('rush-processing-shipping-insurance')
      ];
      currentCheckboxes.forEach(cb => { if (cb) cb.disabled = true; });

      try {
        const cartItemsEl = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
        const sectionsToRender = (cartItemsEl && typeof cartItemsEl.getSectionsToRender === 'function') ? cartItemsEl.getSectionsToRender() : [
          {
            id: 'main-cart-items',
            section: document.getElementById('main-cart-items')?.dataset?.id || 'main-cart-items',
            selector: '#main-cart-items',
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
          {
            id: 'main-cart-footer',
            section: document.getElementById('main-cart-footer')?.dataset?.id || 'main-cart-footer',
            selector: '.js-contents',
          },
          {
            id: 'main-cart-items-addons',
            section: document.getElementById('main-cart-items')?.dataset?.id || 'main-cart-items',
            selector: '#main-cart-items-addons',
          }
        ];

        const bodyData = {
          updates: {
            [variantId]: isChecked ? 1 : 0
          },
          sections: sectionsToRender.map(s => s.section),
          sections_url: window.location.pathname
        };

        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(bodyData)
        });

        const parsedState = await response.json();

        if (parsedState.errors) {
          console.error(parsedState.errors);
          newCheckbox.checked = !isChecked; // Revert checkbox check state on error
          return;
        }

        // DOM update: replace returned sections
        sectionsToRender.forEach(section => {
          const containerEl = document.getElementById(section.id);
          if (!containerEl) return;
          const elementToReplace = containerEl.querySelector(section.selector) || containerEl;
          const sectionHtml = parsedState.sections[section.section];
          if (elementToReplace && sectionHtml) {
            if (cartItemsEl && typeof cartItemsEl.getSectionInnerHTML === 'function') {
              elementToReplace.innerHTML = cartItemsEl.getSectionInnerHTML(sectionHtml, section.selector);
            } else {
              const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
              const innerNode = doc.querySelector(section.selector) || doc.body;
              elementToReplace.innerHTML = innerNode.innerHTML;
            }
          }
        });

        // Trigger cart update event to sync other widgets/elements (like cart drawer)
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState });
        }

        // Re-initialize event listeners and UI on the newly replaced HTML
        initCartAddons();

      } catch (error) {
        console.error('Error updating addon cart item:', error);
        newCheckbox.checked = !isChecked; // Revert state on error
        initCartAddons();
      } finally {
        if (mainCartItems) mainCartItems.classList.remove('cart__items--disabled');
      }
    });
  });

  // Gift Message Popup Modal Handlers
  initGiftMessageHandlers();

  // Footer Addons Handlers
  initFooterAddons();
}

function cleanUpStaleModals() {
  // Clean up any stale/duplicate gift message modals first
  const giftIds = ['PopupModal-gift-message', 'PopupModal-gift-preview'];
  giftIds.forEach(id => {
    const instances = Array.from(document.body.querySelectorAll(`#${id}`));
    if (instances.length > 1) {
      instances.slice(0, instances.length - 1).forEach(inst => inst.remove());
    }
  });

  // Clean up stale and duplicate product details modals at the bottom of the body
  const activeModalIds = Array.from(document.querySelectorAll('modal-opener'))
    .map(opener => opener.getAttribute('data-modal'))
    .filter(Boolean);

  const labelModals = Array.from(document.body.querySelectorAll('modal-dialog[id^="PopupModal-label-cart-"]'));
  
  // 1. Remove completely stale modals (not referenced by any current modal-opener)
  labelModals.forEach(modal => {
    const selector = `#${modal.id}`;
    if (!activeModalIds.includes(selector)) {
      modal.remove();
    }
  });

  // 2. Remove duplicate instances of active modals, keeping only the newest (last in DOM order)
  const uniqueActiveIds = Array.from(new Set(activeModalIds.map(sel => sel.substring(1))));
  uniqueActiveIds.forEach(id => {
    const instances = Array.from(document.body.querySelectorAll(`#${id}`));
    if (instances.length > 1) {
      instances.slice(0, instances.length - 1).forEach(inst => inst.remove());
    }
  });
}

function initGiftMessageHandlers() {
  // Clean up any stale/duplicate modals at the bottom of the body first
  cleanUpStaleModals();

  const labelOpener = document.getElementById('lavel-show-totals');
  const modal = document.getElementById('PopupModal-gift-message');
  
  if (labelOpener && modal) {
    // Clone and replace to prevent multiple event listener attachments
    const newLabel = labelOpener.cloneNode(true);
    labelOpener.parentNode.replaceChild(newLabel, labelOpener);

    newLabel.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (typeof modal.show === 'function') {
        modal.show(newLabel);
      }
    });
  }

  // Bind character counters globally
  window.countChar = function(val) {
    const len = val.value.length;
    const el = document.getElementById('charNum');
    if (el) el.textContent = `${25 - len} characters remaining`;
  };
  window.countCharx = function(val) {
    const len = val.value.length;
    const el = document.getElementById('charNumx');
    if (el) el.textContent = `${25 - len} characters remaining`;
  };
  window.countCharz = function(val) {
    const len = val.value.length;
    const el = document.getElementById('charNumz');
    if (el) el.textContent = `${300 - len} characters remaining`;
  };

  // Set initial counter states if fields are filled
  const toInput = document.getElementById('gift-message-to-input');
  const fromInput = document.getElementById('gift-message-from-input');
  const textareaInput = document.getElementById('gift-message-textarea');
  if (toInput) window.countChar(toInput);
  if (fromInput) window.countCharx(fromInput);
  if (textareaInput) window.countCharz(textareaInput);
  // Save Message button AJAX handler
  const saveBtn = document.getElementById('save-gift-message-btn');
  if (saveBtn) {
    // Clone and replace to prevent duplicate listeners
    const newSaveBtn = saveBtn.cloneNode(true);
    saveBtn.parentNode.replaceChild(newSaveBtn, saveBtn);

    newSaveBtn.addEventListener('click', async (event) => {
      event.preventDefault();

      const toVal = toInput ? toInput.value.trim() : '';
      const fromVal = fromInput ? fromInput.value.trim() : '';
      const textVal = textareaInput ? textareaInput.value.trim() : '';

      if (!toVal || !fromVal || !textVal) {
        alert('Please fill out all fields (To, From, and Message) before saving.');
        return;
      }

      // Show loading/loader state on the save button
      newSaveBtn.textContent = 'Saving...';
      newSaveBtn.disabled = true;

      const giftCheckbox = document.getElementById('gift-message');
      if (!giftCheckbox) {
        newSaveBtn.textContent = 'Save Message';
        newSaveBtn.disabled = false;
        return;
      }

      const variantId = giftCheckbox.dataset.variantId;
      const mainCartItems = document.getElementById('main-cart-items');
      if (mainCartItems) mainCartItems.classList.add('cart__items--disabled');

      try {
        // Fetch current cart state and construct updates to remove ALL existing gift message items first
        const cartRes = await fetch('/cart.js');
        const cartData = await cartRes.json();
        const removeUpdates = {};
        let hasExisting = false;

        cartData.items.forEach(item => {
          if (item.product_handle === 'gift-message' || item.variant_id == variantId) {
            removeUpdates[item.key] = 0;
            hasExisting = true;
          }
        });

        if (hasExisting) {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: removeUpdates })
          });
        }

        const cartItemsEl = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
        const sectionsToRender = (cartItemsEl && typeof cartItemsEl.getSectionsToRender === 'function') ? cartItemsEl.getSectionsToRender() : [
          { id: 'main-cart-items', section: document.getElementById('main-cart-items')?.dataset?.id || 'main-cart-items', selector: '#main-cart-items' },
          { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
          { id: 'main-cart-footer', section: document.getElementById('main-cart-footer')?.dataset?.id || 'main-cart-footer', selector: '.js-contents' },
          { id: 'main-cart-items-addons', section: document.getElementById('main-cart-items')?.dataset?.id || 'main-cart-items', selector: '#main-cart-items-addons' }
        ];

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1,
              properties: {
                to: toVal,
                from: fromVal,
                text: textVal
              }
            }],
            sections: sectionsToRender.map(s => s.section),
            sections_url: window.location.pathname
          })
        });

        const parsedState = await response.json();

        // Update DOM sections
        sectionsToRender.forEach(section => {
          const containerEl = document.getElementById(section.id);
          if (!containerEl) return;
          const elementToReplace = containerEl.querySelector(section.selector) || containerEl;
          const sectionHtml = parsedState.sections[section.section];
          if (elementToReplace && sectionHtml) {
            if (cartItemsEl && typeof cartItemsEl.getSectionInnerHTML === 'function') {
              elementToReplace.innerHTML = cartItemsEl.getSectionInnerHTML(sectionHtml, section.selector);
            } else {
              const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
              const innerNode = doc.querySelector(section.selector) || doc.body;
              elementToReplace.innerHTML = innerNode.innerHTML;
            }
          }
        });

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState });
        }

        if (modal && typeof modal.hide === 'function') modal.hide();

        // Reset the save button state on success
        newSaveBtn.textContent = 'Save Message';
        newSaveBtn.disabled = false;

        // Run initCartAddons() first to clean up duplicate modals and bind listeners to the new instances
        initCartAddons();

        // Automatically show the new preview modal with the updated text values
        const previewModalEl = document.getElementById('PopupModal-gift-preview');
        if (previewModalEl) {
          updatePreviewModalContent(toVal, fromVal, textVal, false);
          if (typeof previewModalEl.show === 'function') {
            // Focus returns to the visible labelOpener when closed to prevent scrolling jumps
            previewModalEl.show(labelOpener);
          }
        }

      } catch (error) {
        console.error('Error saving gift message:', error);
        newSaveBtn.textContent = 'Save Message';
        newSaveBtn.disabled = false;
        if (mainCartItems) mainCartItems.classList.remove('cart__items--disabled');
      }
    });
  }

  // Remove Message AJAX handler
  const removeBtn = document.getElementById('remove-gift-message-btn');
  if (removeBtn) {
    // Clone and replace to prevent duplicate listeners
    const newRemoveBtn = removeBtn.cloneNode(true);
    removeBtn.parentNode.replaceChild(newRemoveBtn, removeBtn);

    newRemoveBtn.addEventListener('click', async (event) => {
      event.preventDefault();

      // Show loading/loader state on the remove button
      newRemoveBtn.textContent = 'Removing...';
      newRemoveBtn.disabled = true;

      const giftCheckbox = document.getElementById('gift-message');
      if (!giftCheckbox) {
        newRemoveBtn.textContent = 'Remove Message';
        newRemoveBtn.disabled = false;
        return;
      }

      const variantId = giftCheckbox.dataset.variantId;

      const mainCartItems = document.getElementById('main-cart-items');
      if (mainCartItems) mainCartItems.classList.add('cart__items--disabled');

      try {
        // Fetch current cart state and construct updates to remove ALL existing gift message items
        const cartRes = await fetch('/cart.js');
        const cartData = await cartRes.json();
        const removeUpdates = {};
        let hasExisting = false;

        cartData.items.forEach(item => {
          if (item.product_handle === 'gift-message' || item.variant_id == variantId) {
            removeUpdates[item.key] = 0;
            hasExisting = true;
          }
        });

        const cartItemsEl = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
        const sectionsToRender = (cartItemsEl && typeof cartItemsEl.getSectionsToRender === 'function') ? cartItemsEl.getSectionsToRender() : [
          { id: 'main-cart-items', section: document.getElementById('main-cart-items')?.dataset?.id || 'main-cart-items', selector: '#main-cart-items' },
          { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
          { id: 'main-cart-footer', section: document.getElementById('main-cart-footer')?.dataset?.id || 'main-cart-footer', selector: '.js-contents' },
          { id: 'main-cart-items-addons', section: document.getElementById('main-cart-items')?.dataset?.id || 'main-cart-items', selector: '#main-cart-items-addons' }
        ];

        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            updates: removeUpdates,
            sections: sectionsToRender.map(s => s.section),
            sections_url: window.location.pathname
          })
        });

        const parsedState = await response.json();

        // Update DOM sections
        sectionsToRender.forEach(section => {
          const containerEl = document.getElementById(section.id);
          if (!containerEl) return;
          const elementToReplace = containerEl.querySelector(section.selector) || containerEl;
          const sectionHtml = parsedState.sections[section.section];
          if (elementToReplace && sectionHtml) {
            if (cartItemsEl && typeof cartItemsEl.getSectionInnerHTML === 'function') {
              elementToReplace.innerHTML = cartItemsEl.getSectionInnerHTML(sectionHtml, section.selector);
            } else {
              const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
              const innerNode = doc.querySelector(section.selector) || doc.body;
              elementToReplace.innerHTML = innerNode.innerHTML;
            }
          }
        });

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState });
        }

        if (modal && typeof modal.hide === 'function') modal.hide();

        // Reset the remove button state on success
        newRemoveBtn.textContent = 'Remove Message';
        newRemoveBtn.disabled = false;

        initCartAddons();

      } catch (error) {
        console.error('Error removing gift message:', error);
        newRemoveBtn.textContent = 'Remove Message';
        newRemoveBtn.disabled = false;
        if (mainCartItems) mainCartItems.classList.remove('cart__items--disabled');
      }
    });
  }

  // Preview & View sample handlers using custom modal-dialog
  const previewLink = document.querySelector('.preview-link');
  const viewSampleLink = document.querySelector('.view-sample-link');
  const previewModal = document.getElementById('PopupModal-gift-preview');

  const updatePreviewModalContent = (to, from, text, isSample = false) => {
    const toEl = document.getElementById('popup-form-namne');
    const textEl = document.getElementById('poptexts');
    const fromEl = document.querySelector('.popup-from-title');
    const editBtn = document.querySelector('#PopupModal-gift-preview .edit-gift-message-btn');
    const goodBtn = document.querySelector('#PopupModal-gift-preview .good-btn');

    if (toEl) toEl.textContent = to || 'John Smith';
    if (textEl) textEl.textContent = text || 'Happy Birthday John! We know you love grilling and cooking, add these to your collection of spices!';
    if (fromEl) fromEl.textContent = from || 'Emily S.';

    if (editBtn) {
      if (isSample) {
        editBtn.style.display = 'none';
      } else {
        editBtn.style.display = '';
      }
    }

    if (goodBtn) {
      goodBtn.textContent = isSample ? 'OK' : 'LOOKS GOOD!';
    }
  };

  if (previewLink && previewModal) {
    // Clone to prevent duplicate listeners
    const newPreviewLink = previewLink.cloneNode(true);
    previewLink.parentNode.replaceChild(newPreviewLink, previewLink);

    newPreviewLink.addEventListener('click', (event) => {
      event.preventDefault();
      const toVal = toInput ? toInput.value.trim() : '';
      const fromVal = fromInput ? fromInput.value.trim() : '';
      const textVal = textareaInput ? textareaInput.value.trim() : '';
      updatePreviewModalContent(toVal, fromVal, textVal, false);

      // Close editor modal
      const mainModal = document.getElementById('PopupModal-gift-message');
      if (mainModal && typeof mainModal.hide === 'function') {
        mainModal.hide();
      }

      // Open preview modal
      if (typeof previewModal.show === 'function') {
        previewModal.show(newPreviewLink);
      }
    });
  }

  if (viewSampleLink && previewModal) {
    // Clone to prevent duplicate listeners
    const newViewSampleLink = viewSampleLink.cloneNode(true);
    viewSampleLink.parentNode.replaceChild(newViewSampleLink, viewSampleLink);

    newViewSampleLink.addEventListener('click', (event) => {
      event.preventDefault();
      updatePreviewModalContent('', '', '', true);

      // Close editor modal
      const mainModal = document.getElementById('PopupModal-gift-message');
      if (mainModal && typeof mainModal.hide === 'function') {
        mainModal.hide();
      }

      // Open preview modal
      if (typeof previewModal.show === 'function') {
        previewModal.show(newViewSampleLink);
      }
    });
  }

  // Handle Edit button click inside preview modal to return to input modal
  const previewEditBtn = document.querySelector('#PopupModal-gift-preview .edit-gift-message-btn');
  if (previewEditBtn) {
    // Clone to prevent duplicate listeners
    const newPreviewEditBtn = previewEditBtn.cloneNode(true);
    previewEditBtn.parentNode.replaceChild(newPreviewEditBtn, previewEditBtn);

    newPreviewEditBtn.addEventListener('click', (event) => {
      event.preventDefault();

      // Hide preview modal
      if (previewModal && typeof previewModal.hide === 'function') {
        previewModal.hide();
      }

      // Show editor modal
      const label = document.getElementById('lavel-show-totals');
      const mainModal = document.getElementById('PopupModal-gift-message');
      if (mainModal && typeof mainModal.show === 'function') {
        mainModal.show(label);
      }
    });
  }

  // Handle LOOKS GOOD / OK button click inside preview modal to close it
  const previewGoodBtn = document.querySelector('#PopupModal-gift-preview .good-btn');
  if (previewGoodBtn) {
    // Clone to prevent duplicate listeners
    const newPreviewGoodBtn = previewGoodBtn.cloneNode(true);
    previewGoodBtn.parentNode.replaceChild(newPreviewGoodBtn, previewGoodBtn);

    newPreviewGoodBtn.addEventListener('click', (event) => {
      event.preventDefault();
      if (previewModal && typeof previewModal.hide === 'function') {
        previewModal.hide();
      }
    });
  }
}

function initFooterAddons() {
  const footerAddons = document.querySelector('.footer-addons');
  if (!footerAddons) return;

  const removeButtons = footerAddons.querySelectorAll('.addon-remove-btn');
  removeButtons.forEach(btn => {
    btn.addEventListener('click', async (event) => {
      event.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.style.pointerEvents = 'none';
      btn.innerHTML = `Removing... <div class="loading__spinner" style="position: static; display: inline-block; vertical-align: middle; width: 1.4rem; height: 1.4rem; margin-left: 5px;"><svg class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" style="width: 100%; height: 100%;"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30" style="stroke: currentColor;"></circle></svg></div>`;

      const mainCartItems = document.getElementById('main-cart-items');
      if (mainCartItems) mainCartItems.classList.add('cart__items--disabled');

      try {
        const cartItemsEl = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
        const sectionsToRender = (cartItemsEl && typeof cartItemsEl.getSectionsToRender === 'function') ? cartItemsEl.getSectionsToRender() : [
          {
            id: 'main-cart-items',
            section: document.getElementById('main-cart-items')?.dataset?.id || 'main-cart-items',
            selector: '#main-cart-items',
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
          {
            id: 'main-cart-footer',
            section: document.getElementById('main-cart-footer')?.dataset?.id || 'main-cart-footer',
            selector: '.js-contents',
          },
          {
            id: 'main-cart-items-addons',
            section: document.getElementById('main-cart-items')?.dataset?.id || 'main-cart-items',
            selector: '#main-cart-items-addons',
          }
        ];

        const bodyData = {
          updates: {
            [variantId]: 0
          },
          sections: sectionsToRender.map(s => s.section),
          sections_url: window.location.pathname
        };

        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(bodyData)
        });

        const parsedState = await response.json();

        if (parsedState.errors) {
          console.error(parsedState.errors);
          return;
        }

        sectionsToRender.forEach(section => {
          const containerEl = document.getElementById(section.id);
          if (!containerEl) return;
          const elementToReplace = containerEl.querySelector(section.selector) || containerEl;
          const sectionHtml = parsedState.sections[section.section];
          if (elementToReplace && sectionHtml) {
            if (cartItemsEl && typeof cartItemsEl.getSectionInnerHTML === 'function') {
              elementToReplace.innerHTML = cartItemsEl.getSectionInnerHTML(sectionHtml, section.selector);
            } else {
              const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
              const innerNode = doc.querySelector(section.selector) || doc.body;
              elementToReplace.innerHTML = innerNode.innerHTML;
            }
          }
        });

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState });
        }

        initCartAddons();

      } catch (error) {
        console.error('Error removing footer addon:', error);
        initCartAddons();
      } finally {
        if (mainCartItems) mainCartItems.classList.remove('cart__items--disabled');
      }
    });
  });

  const giftRemoveBtn = footerAddons.querySelector('.remove-message-btn-footer');
  if (giftRemoveBtn) {
    giftRemoveBtn.addEventListener('click', async (event) => {
      event.preventDefault();
      const variantId = giftRemoveBtn.dataset.variantId;
      if (!variantId) return;

      giftRemoveBtn.style.pointerEvents = 'none';
      giftRemoveBtn.innerHTML = `Removing... <div class="loading__spinner" style="position: static; display: inline-block; vertical-align: middle; width: 1.4rem; height: 1.4rem; margin-left: 5px;"><svg class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" style="width: 100%; height: 100%;"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30" style="stroke: currentColor;"></circle></svg></div>`;

      const mainCartItems = document.getElementById('main-cart-items');
      if (mainCartItems) mainCartItems.classList.add('cart__items--disabled');

      try {
        const cartRes = await fetch('/cart.js');
        const cartData = await cartRes.json();
        const removeUpdates = {};
        let hasExisting = false;

        cartData.items.forEach(item => {
          if (item.product_handle === 'gift-message' || item.variant_id == variantId) {
            removeUpdates[item.key] = 0;
            hasExisting = true;
          }
        });

        const cartItemsEl = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
        const sectionsToRender = (cartItemsEl && typeof cartItemsEl.getSectionsToRender === 'function') ? cartItemsEl.getSectionsToRender() : [
          { id: 'main-cart-items', section: document.getElementById('main-cart-items')?.dataset?.id || 'main-cart-items', selector: '#main-cart-items' },
          { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
          { id: 'main-cart-footer', section: document.getElementById('main-cart-footer')?.dataset?.id || 'main-cart-footer', selector: '.js-contents' },
          { id: 'main-cart-items-addons', section: document.getElementById('main-cart-items')?.dataset?.id || 'main-cart-items', selector: '#main-cart-items-addons' }
        ];

        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            updates: removeUpdates,
            sections: sectionsToRender.map(s => s.section),
            sections_url: window.location.pathname
          })
        });

        const parsedState = await response.json();

        sectionsToRender.forEach(section => {
          const containerEl = document.getElementById(section.id);
          if (!containerEl) return;
          const elementToReplace = containerEl.querySelector(section.selector) || containerEl;
          const sectionHtml = parsedState.sections[section.section];
          if (elementToReplace && sectionHtml) {
            if (cartItemsEl && typeof cartItemsEl.getSectionInnerHTML === 'function') {
              elementToReplace.innerHTML = cartItemsEl.getSectionInnerHTML(sectionHtml, section.selector);
            } else {
              const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
              const innerNode = doc.querySelector(section.selector) || doc.body;
              elementToReplace.innerHTML = innerNode.innerHTML;
            }
          }
        });

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState });
        }

        initCartAddons();

      } catch (error) {
        console.error('Error removing gift message:', error);
        initCartAddons();
      } finally {
        if (mainCartItems) mainCartItems.classList.remove('cart__items--disabled');
      }
    });
  }

  const giftEditBtn = footerAddons.querySelector('#edits-edits-footer') || footerAddons.querySelector('#edits-edits');
  const modal = document.getElementById('PopupModal-gift-message');
  if (giftEditBtn && modal) {
    giftEditBtn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (typeof modal.show === 'function') {
        modal.show(giftEditBtn);
      }
    });
  }
}

// Subscribe to pubsub cart updates to re-init our addons UI states
document.addEventListener('DOMContentLoaded', () => {
  initCartAddons();
  initBundleRemovalModal();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      // Re-run UI state update after DOM re-renders from cart actions
      setTimeout(initCartAddons, 100);
    });
  }
});

function initBundleRemovalModal() {
  const modal = document.getElementById('CartBundleModal');
  if (!modal) return;

  const closeBtn = modal.querySelector('.cart-bundle-modal-x');
  const cancelBtn = modal.querySelector('#CartBundleModalCancelBtn');
  const removeSingleBtn = modal.querySelector('#CartBundleModalRemoveSingleBtn');
  const removeBundleBtn = modal.querySelector('#CartBundleModalRemoveBundleBtn');

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  }

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (cancelBtn) cancelBtn.addEventListener('click', closeModal);
  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  // Handle Remove Single
  if (removeSingleBtn) {
    removeSingleBtn.addEventListener('click', () => {
      const lineIndex = modal.dataset.lineIndex;
      closeModal();
      
      const cartItemsEl = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
      if (cartItemsEl && lineIndex) {
        cartItemsEl.updateQuantity(
          lineIndex,
          0,
          { currentTarget: document.querySelector(`.cart-bundle-remove-trigger[data-index="${lineIndex}"]`), preventDefault: () => {} }
        );
      }
    });
  }

  // Handle Remove Bundle
  if (removeBundleBtn) {
    removeBundleBtn.addEventListener('click', async () => {
      const bundleTag = modal.dataset.bundleTag;
      closeModal();
      if (!bundleTag) return;

      const mainCartItems = document.getElementById('main-cart-items');
      if (mainCartItems) mainCartItems.classList.add('cart__items--disabled');

      try {
        const itemElements = document.querySelectorAll(`.cart-item[data-bundle-tag="${bundleTag}"]`);
        const updates = {};
        itemElements.forEach(itemEl => {
          const key = itemEl.dataset.key;
          if (key) {
            updates[key] = 0;
          }
        });

        const cartItemsEl = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
        const sectionsToRender = (cartItemsEl && typeof cartItemsEl.getSectionsToRender === 'function') ? cartItemsEl.getSectionsToRender() : [
          { id: 'main-cart-items', section: document.getElementById('main-cart-items')?.dataset?.id || 'main-cart-items', selector: '#main-cart-items' },
          { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
          { id: 'main-cart-footer', section: document.getElementById('main-cart-footer')?.dataset?.id || 'main-cart-footer', selector: '.js-contents' },
          { id: 'main-cart-items-addons', section: document.getElementById('main-cart-items')?.dataset?.id || 'main-cart-items', selector: '#main-cart-items-addons' }
        ];

        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            updates: updates,
            sections: sectionsToRender.map(s => s.section),
            sections_url: window.location.pathname
          })
        });

        const parsedState = await response.json();

        sectionsToRender.forEach(section => {
          const containerEl = document.getElementById(section.id);
          if (!containerEl) return;
          const elementToReplace = containerEl.querySelector(section.selector) || containerEl;
          const sectionHtml = parsedState.sections[section.section];
          if (elementToReplace && sectionHtml) {
            if (cartItemsEl && typeof cartItemsEl.getSectionInnerHTML === 'function') {
              elementToReplace.innerHTML = cartItemsEl.getSectionInnerHTML(sectionHtml, section.selector);
            } else {
              const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
              const innerNode = doc.querySelector(section.selector) || doc.body;
              elementToReplace.innerHTML = innerNode.innerHTML;
            }
          }
        });

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState });
        }

        if (typeof initCartAddons === 'function') {
          initCartAddons();
        }

      } catch (error) {
        console.error('Error removing bundle:', error);
      } finally {
        if (mainCartItems) mainCartItems.classList.remove('cart__items--disabled');
      }
    });
  }

  // Event delegation for trigger click
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.cart-bundle-remove-trigger');
    if (!trigger) return;

    e.preventDefault();
    modal.dataset.lineIndex = trigger.dataset.index;
    modal.dataset.variantId = trigger.dataset.variantId;
    modal.dataset.key = trigger.dataset.key;
    modal.dataset.bundleTag = trigger.dataset.bundleTag;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
  });
}

